/* eslint-disable */
import Loader from "@/components/common/loader";
import mixins from "@/mixins";
import App from "./App.vue";

import { provideStore } from "redux-vuex";
import { createApp } from "vue";
import { createI18n } from "vue-i18n";
import en from "./locales/en";
import fr from "./locales/fr";
import pt from "./locales/pt";

// import i18n from './i18n';
import { getValueAtPath } from "./runtime/utils";

function __debug__(store) {
    // let __STORE__, previousState;

    // function handler() {
    //     const currentState = window.$store.state;

    //     console.log(window.$store);

    //     if (!(previousState && previousState === currentState)) {
    //         console.log((previousState = currentState));
    //     }
    // }

    // (__debug__ = function debug(store) {
    //     if (store !== __STORE__ && (__STORE__ = store)) {
    //         const { dispatch, getState, subscribe, ...actions } = store;

    //         window.$store = Object.freeze(
    //             Object.defineProperties({ ...actions }, {
    //                 state: { get: getState },
    //                 unsubscribe: { value: subscribe(handler) },
    //             })
    //         );

    //         handler();
    //     }
    // }).call(this, store);
}

dispatchEvent(new CustomEvent("checkout:app", {
    bubbles: false,
    cancelable: false
}));

addEventListener("checkout:ready", function _ready(evt) {
    removeEventListener("checkout:ready", _ready, false);

    if (Object.prototype.toString.call(evt.detail) === "[object Object]") {
        const app = createApp(App);
        const store = evt.detail.store;
        const { dispatch, getState, subscribe, ...actions } = store;

        if (window.top !== window.self) {
            let parentWindow;

            if (
                (parentWindow = window.opener || window.parent) &&
                parentWindow !== window.self
            ) {
                ["readytorecieve", "modalready", "allcontentloaded"]
                    .forEach(name => {
                        parentWindow.postMessage({ name }, "*");
                    });
            }
        }

        let locale;
        const stateObject = getState();
        if (stateObject) {
            locale = getValueAtPath(stateObject, 'locale');
        }

        const i18n = createI18n({
            legacy: false,
            globalInjection: true,
            locale: locale || "en",
            fallbackLocale: "en",
            messages: {
                en: en,
                fr: fr,
                pt: pt,

            }
        })

        provideStore({ app, store });
        __debug__(store);

        app.component("Loader", Loader);
        app.provide("actions", actions);
        app.mixin(mixins);
        
        app.use(i18n).mount("#app");
    }
}, false);
